import PropTypes from 'prop-types';

import AppBanner from 'components/Sidebar/AppBanner';
import SignInCard from 'components/SignInCard';

import { sendEvent } from 'lib/gtag';

import { useUser } from 'providers/UserProvider';

import AdPlaceholder from './AdPlaceholder';
import CouponsCard from './CouponsCard';
import FeaturedStores from './FeaturedStores';
import WhatsAppBanner from './WhatsAppBanner';
import WhatsAppCard from './WhatsAppCard';

const GA_EVENT_CATEGORY = 'timeline';

const HomeSidebar = ({
  isUserLogged = false,
  sidebarAds = [],
  serverCoupons,
  serverFeaturedStores,
}) => {
  const { isLoggedIn, loadingLoggedInUser } = useUser();
  const sortedAds = [...sidebarAds].sort((a, b) => a.position - b.position);
  // SSR/hydration uses the `is_user_logged` cookie (see pages/index.js). After
  // the client resolves the real auth state, prefer it — this only diverges on
  // the token-expiration boundary (cookie survives longer than the JWT).
  const showWhatsApp = loadingLoggedInUser ? isUserLogged : isLoggedIn;

  return (
    <>
      {showWhatsApp ? (
        <WhatsAppCard />
      ) : (
        <SignInCard className="w-full" gaEventCategory="home_sidebar" />
      )}
      <CouponsCard initialCoupons={serverCoupons} />
      <FeaturedStores initialStores={serverFeaturedStores} />
      <div className="hidden">
        <AppBanner />
      </div>
      <div className="hidden">
        <WhatsAppBanner />
      </div>
      {sortedAds.map((ad) => (
        <a
          key={ad.id}
          className="block overflow-hidden rounded-3"
          href={ad.url}
          rel="noopener noreferrer"
          target="_blank"
          onClick={() =>
            sendEvent({
              action: 'home_ads_banner',
              category: GA_EVENT_CATEGORY,
            })
          }
        >
          <img
            alt={ad.description}
            className="w-full object-cover"
            src={ad.image}
          />
        </a>
      ))}
      <AdPlaceholder />
    </>
  );
};

HomeSidebar.propTypes = {
  isUserLogged: PropTypes.bool,
  sidebarAds: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      image: PropTypes.string.isRequired,
      position: PropTypes.number.isRequired,
      url: PropTypes.string.isRequired,
    })
  ),
  serverCoupons: PropTypes.array,
  serverFeaturedStores: PropTypes.array,
};

export default HomeSidebar;
